export default "<h4>Componente de stepper</h4>\n";